import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, Typography, Grid } from '@mui/material';

const THEME = { primary: "rgb(44, 52, 123)", primaryRgba: (a) => `rgba(44, 52, 123, ${a})` };

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiBackdrop-root': {
        backgroundColor: theme.palette.mode === 'dark'
            ? 'rgba(0, 0, 0, 0.6)'
            : 'rgba(0, 0, 0, 0.4)'
    },
    '& .MuiDialog-container': {
        padding: theme.spacing(2)
    },
    '& .MuiDialog-paper': {
        borderRadius: 8,
        border: `1px solid ${THEME.primaryRgba(0.15)}`,
        maxWidth: '600px',
        width: '100%',
        margin: theme.spacing(2),
        backgroundColor: theme.palette.mode === 'dark'
            ? theme.palette.grey[900]
            : theme.palette.background.paper,
        boxShadow: `0 4px 20px ${THEME.primaryRgba(0.08)}, 0 2px 8px rgba(0,0,0,0.06)`,
        position: 'relative',
        overflow: 'hidden',
        '&:focus-visible': {
            outline: 'none'
        }
    }
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    padding: theme.spacing(1.25, 2),
    backgroundColor: theme.palette.mode === 'dark'
        ? theme.palette.grey[900]
        : THEME.primary,
    color: theme.palette.mode === 'dark' ? undefined : '#ffffff',
    borderBottom: `1px solid ${theme.palette.mode === 'dark'
        ? theme.palette.grey[800]
        : THEME.primaryRgba(0.2)}`,
    '& .MuiTypography-h6': {
        color: theme.palette.mode === 'dark'
            ? theme.palette.grey[100]
            : '#ffffff',
        fontSize: '0.95rem',
        fontWeight: 600
    },
    '& .MuiIconButton-root': {
        color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : 'rgba(255,255,255,0.9)',
        '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.15)'
        }
    }
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(2.5, 2, 2, 2),
    backgroundColor: theme.palette.mode === 'dark'
        ? theme.palette.grey[900]
        : theme.palette.background.paper,
    '& .MuiGrid-container': {
        marginTop: 0
    },
    overflowX: 'hidden'
}));

export const HeaderContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .MuiIconButton-root': {
        padding: theme.spacing(0.5),
        marginRight: theme.spacing(-0.5),
        color: 'inherit',
        '&:hover': {
            backgroundColor: theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(255, 255, 255, 0.15)'
        }
    }
}));

export const IconContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& .MuiSvgIcon-root': {
        fontSize: 20,
        color: theme.palette.mode === 'dark' ? theme.palette.primary.main : '#ffffff'
    }
}));

export const FormContainer = styled('form')({
    width: '100%'
});

export const ButtonGroup = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
}));

export const LabelTypography = styled(Typography)(({ theme }) => ({
    marginBottom: '4px',
    fontWeight: 500,
    color: theme.palette.mode === 'dark'
        ? theme.palette.grey[300]
        : theme.palette.text.secondary,
    fontSize: '0.875rem'
}));

export const GridContainer = styled(Grid)(({ theme }) => ({
    width: '100%',
    margin: 0,
    '& .MuiGrid-item': {
        paddingTop: '12px',
        paddingBottom: '12px'
    },
    '& .MuiFormControlLabel-root': {
        marginLeft: -6,
        marginRight: 0
    }
}));
